import { DONATION_ROUTES, SEARCH_PARAMS } from '@/constants';

export const inviteLinkOf = (origin: string, memberCode: string) => {
  const url = new URL(DONATION_ROUTES.HOME.pathname, origin);

  url.searchParams.set(SEARCH_PARAMS.SHARE_BY, memberCode);

  return { href: url.href, label: `${url.host}${url.pathname}${url.search}` };
};
